import React, { useContext } from 'react'
import { WidgetContext } from '../../Widget2'

const Overview = ({ userAppointmentCalendar, userAppointmentCalendars, onBack }) => {
  const { brand } = useContext(WidgetContext)

  const { name, logo } = brand.attributes

  function handleBack(e) {
    e.preventDefault()
    onBack && onBack()
  }


  return (
    <div className="appointment-scheduler-overview">
      { logo &&
      <div className="appointment-scheduler-overview-header">
        <img src={logo.defaultLogoVariant} srcSet={`${logo.defaultVariant} 1x, ${logo.hiResVariant} 2x`} alt={name} className="appointment-scheduler-overview-logo" />
      </div>
      }
      {userAppointmentCalendar &&
        <div className="appointment-scheduler-overview-content">
          <h1>{ userAppointmentCalendar.attributes.title }</h1>
          <h2>{ userAppointmentCalendar.attributes.fullName }</h2>
          <div className="appointment-scheduler-overview-meta">{ userAppointmentCalendar.attributes.defaultLengthInMinutes } minutes</div>

          <div className="mt-3">
            <div className="ql-content-wrapper" dangerouslySetInnerHTML={{ __html: userAppointmentCalendar.attributes.invitationMessageHtml }} />
          </div>

          { userAppointmentCalendars.length > 1 &&
          <div className="mt-3">
            <a href="#back" onClick={onBack}>&laquo; Change</a>
          </div>
          }
        </div>
      }
    </div>
  )
}

export default Overview
